import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Amber warning banner shown when the user's MFA enforcement deadline is
 * within 7 days AND they haven't enrolled yet. Auto-hides once enrolled. */
export default function MFADeadlineBanner({ user }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!user || user.mfa_enabled) return;
    if (!['super_admin', 'org_admin'].includes(user.role)) return;
    let cancel = false;
    axios.get(`${API}/security/mfa-deadline-status`)
      .then(res => { if (!cancel) setState(res.data); })
      .catch(() => {});
    return () => { cancel = true; };
  }, [user]);

  if (!state?.warning) return null;

  return (
    <div className="border-b bg-amber-950/80 border-amber-500/40 text-amber-100" data-testid="mfa-deadline-banner">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse flex-shrink-0" />
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span>
          {state.passed
            ? <><strong>MFA enrollment deadline has passed.</strong> Complete setup now — logins are being blocked. </>
            : <><strong>{state.days_left === 0 ? 'Today' : `${state.days_left} day${state.days_left !== 1 ? 's' : ''} left`}</strong> to enroll in MFA before it becomes mandatory. </>}
          <Link to="/security" className="underline font-semibold hover:opacity-80" data-testid="mfa-deadline-cta">
            Enroll now →
          </Link>
        </span>
      </div>
    </div>
  );
}
